export const BASE_URL = `https://mediaclass-license.palatine.ru`;
//export const BASE_URL = `http://localhost:13500`;